import React, { Fragment } from 'react';

const BringToBooking = () => (
  <Fragment>
    <p>
      To make the most of your booking, you'll need the following items:
    </p>
    <ol>
      <li>
        12V cigarette lighter adapter + phone charging cable to charge your
        phone while on the road or
      </li>
      <li>USB-C phone charging cable to keep your phone charged up.</li>
    </ol>
    <p>
      Watch our tutorial{' '}
      <a
        className="faq__panel--link"
        href="https://www.youtube.com/watch?v=PkndDil47Fo&list=PLypJbLBqp9zicsWFtZd4ILySpShdpxOXu&index=3"
        target="_blank">
        here
      </a>{' '}
      on how to prepare for your booking.
    </p>
  </Fragment>
);

export default BringToBooking;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/MakingABooking/BringToBooking.js